//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'dev',
  title: 'Sierra Production',
  name: 'sierra-production',
  asset: {
    stationAssetTypeReference: '67abfb9aee06eac3505f9834',
  },
  // E-signature pages (preview): off in prod; elsewhere only for the SignaturePreview role.
  features: {
    signature: true,
    /** Access catalog page (#6265): preview, off in prod. */
    accessCatalog: true,
  },
  proxyUrls: {
    assetApi: 'https://asset.api.dev.sierra-erp.com',
    itemApi: 'https://item.api.dev.sierra-erp.com',
    userMasterApi: 'https://user.api.dev.sierra-erp.com',
    inventoryApi: 'https://inventory.api.dev.sierra-erp.com',
    orderApi: 'https://order.api.dev.sierra-erp.com',
    productionApi: 'https://production.api.dev.sierra-erp.com',
  },
  externalSitesUrls: {
    itemModule: 'sierra.textiles.come',
  },
};
